<template>
  <Toast />
  <div class="p-grid">
    <div class="p-col-12">
      <Panel header="Finalizar Solicitações">
        <DataTable
          ref="dt"
          dataKey="id"
          class="p-datatable-sm"
          :value="list"
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 20, 50, 100, 500, 1000]"
          :filters="filters"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Exibindo de {first} a {last} no total de {totalRecords} solicitações."
          :lazy="true"
          :totalRecords="totalRecords"
          :loading="loading"
          @page="onPage($event)"
          @filter="onFilter($event)"
          @sort="onSort($event)"
        >
          <Column header="#" field="id">
            <template #body="slotProps">
              {{ slotProps.data.id }}
            </template>
          </Column>
          <Column header="Solicitante" field="requesterName">
            <template #body="slotProps">
              {{ slotProps.data.requester }}
            </template>
          </Column>
          <Column header="Setor" field="sectorAcronym">
            <template #body="slotProps">
              {{ slotProps.data.acronym }}
            </template>
          </Column>
          <Column header="Prioridade" field="priority">
            <template #body="slotProps">
              <span
                :class="'solicitacao-badge status-' + slotProps.data.priority"
                >{{ $Util.formatBoolean(slotProps.data.priority) }}</span
              >
            </template>
          </Column>
          <Column header="Situação" field="status" filterField="status">
            <template #body="slotProps">
              <span
                :class="
                  'solicitacao-badge status-' +
                  slotProps.data.status.toLowerCase()
                "
                >{{ $Util.formatStatus(slotProps.data.status) }}</span
              >
            </template>
          </Column>
          <Column header="Data" field="date">
            <template #body="slotProps">
              {{ $DateTime.formatarDateTime24hours(slotProps.data.date) }}
            </template>
          </Column>
          <Column header="Ações">
            <template #body="slotProps">
              <Button
                icon="pi pi-download"
                class="p-button-rounded mr-2"
                @click="showDownload(slotProps.data)"
                v-tooltip.top="'CLIQUE PARA BAIXAR'"
              />
              <Button
                icon="pi pi-check"
                class="p-button-rounded p-button-success mr-2"
                @click="showFinalizar(slotProps.data)"
                v-tooltip.top="'CLIQUE PARA FINALIZAR'"
              />
            </template>
          </Column>
        </DataTable>
      </Panel>
    </div>
  </div>

  <!--MODAL CADASTRAR-->
  <dialog-finishing :objSelected="obj" @findAll="loadLazyData" />
  <!--FIM MODAL CADASTRAR-->
</template>

<script>
//models
//import Solicitation from "../../models/internal/solicitation";
import { StatusSolicitation } from "../../models/enums/Status";

//Services
import SolicitationService from "../../service/solicitation/solicitation_service";
//components
import DialogFinishing from "../finalize_solicitation/components/dialog_finishing.vue";

export default {
  components: {
    DialogFinishing,
  },
  data() {
    return {
      loading: false,
      list: [],
      obj: {},
      filters: {
        status: { value: "EM_ABERTO", matchMode: "contains" },
      },
      service: new SolicitationService(),
      StatusSolicitation,
      lazyParams: {},
    };
  },
  created() {},
  mounted() {
    this.lazyParams = {
      first: 0,
      rows: this.$refs.dt.rows,
      sortField: null,
      sortOrder: null,
      status: "",
    };
    this.loadLazyData();
  },
  methods: {
    showFinalizar(objDto) {
      this.obj = objDto;
      this.$store.state.views.solicitation.finalize.dialogAttending = true;
    },
    loadLazyData() {
      this.loading = true;
      //LIMPEZA FILTRO
      this.lazyParams.status =
        this.lazyParams.status == null ? "" : this.lazyParams.status;
      this.service
        .findByStatus(this.lazyParams)
        .then((data) => {
          this.list = data.content;
          this.totalRecords = data.totalElements;
          this.loading = false;
        })
        .catch(() => {
          this.$toast.add({
            severity: "error",
            detail: `Desculpe. Não foi possível carregar os dados.`,
          });
          this.loading = false;
          this.list = [];
        });
    },
    onPage(event) {
      this.lazyParams.rows = event.rows;
      this.lazyParams.page = event.page;
      this.loadLazyData();
    },
    onSort(event) {
      this.lazyParams.sortField = event.sortField;
      this.lazyParams.sortOrder = event.sortOrder;
      this.loadLazyData();
    },
    onFilter(event) {
      this.lazyParams.page = 0;
      this.lazyParams.status = event.filters.status.value;

      this.loadLazyData();
    },
    showDownload(value) {
      window.open(
        `${window.location.origin}/#/pdf-os?solicitacao_id=${value.id}`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../../App.scss");
</style>
